<template>
	<div class="work-order-container">
		<!-- 顶部搜索与操作栏 -->
		<div class="header-card">
			<el-form :model="searchForm" class="demo-form-inline">
				
				<el-form-item style="justify-content: left;">
					<el-button type="primary" @click="openCreateDialog">创建工单</el-button>
				</el-form-item>
			</el-form>
		</div>

		<!-- 数据表格区域 -->
		<div class="table-card">
			<el-table 
				:data="workList" 
				style="width: 100%" 
				v-loading="tableLoading"
				border
				stripe
				:header-cell-style="{background:'#f5f7fa', color:'#606266'}">
				
				<el-table-column prop="waybillNo" label="运单号" min-width="140">
					<template #default="scope">
						<div class="waybill-cell">
							<span class="waybill-text" @click="waybillQueryPopup(scope.row)" title="点击查询物流">{{ scope.row.waybillNo }}</span>
							<!-- CopyDocument 仍在使用 -->
							<el-icon class="copy-icon" @click="common.copy(scope.row.waybillNo)" title="复制运单号"><CopyDocument /></el-icon>
						</div>
					</template>
				</el-table-column>
				
				<el-table-column prop="typeName" label="工单类型" width="120">
					<template #default="scope">
						<el-tag :type="scope.row.typeCode === 'intercept' ? 'warning' : 'success'" effect="light">
							{{ scope.row.typeName }}
						</el-tag>
					</template>
				</el-table-column>
				
				<el-table-column prop="statusName" label="工单状态" width="120">
					<template #default="scope">
						<el-tag :type="getStatusType(scope.row.statusCode)" effect="plain">
							{{ scope.row.statusName }}
						</el-tag>
					</template>
				</el-table-column>
				
				<el-table-column prop="latestRouteText" label="最新轨迹/备注" min-width="200" show-overflow-tooltip />
				
				<el-table-column prop="createTime" label="创建时间" width="180" align="center" />
				
				<el-table-column label="操作" width="150" fixed="right" align="center">
					<!-- <template #default="scope">
						<el-button link type="primary" size="small" @click="viewDetail(scope.row)">查看</el-button>
						<el-button link type="danger" size="small" v-if="scope.row.statusCode === 'PROCESSING'" @click="cancelWorkOrder(scope.row.id)">取消</el-button>
					</template> -->
				</el-table-column>
			</el-table>

			<!-- 分页 -->
			<div class="pagination-container">
				<el-pagination
					v-model:current-page="pagination.currentPage"
					v-model:page-size="pagination.pageSize"
					:page-sizes="[10, 20, 50, 100]"
					:total="pagination.total"
					layout="total, sizes, prev, pager, next, jumper"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				/>
			</div>
		</div>

		<!-- 创建工单弹窗 -->
		<el-dialog 
			v-model="showCreateWorkOrder" 
			title="创建新工单" 
			width="650px" 
			@opened="dialogOpened"
			:close-on-click-modal="false">
			
			<el-form ref="workFormRef" :model="workForm.workData" :rules="rules" label-width="90px" class="custom-form">
				
				<!-- 工单类型选择 -->
				<el-form-item label="工单类型" prop="workTypeCode">
					<div class="type-selector">
						<div 
							v-for="item in workTypeList" 
							:key="item.code"
							class="type-btn"
							:class="{ active: workForm.workType === item.code }"
							@click="workForm.workType = item.code">
							{{ item.name }}
						</div>
					</div>
				</el-form-item>

				<el-divider content-position="left">基础信息</el-divider>

				<el-form-item label="运单号" prop="waybillNo">
					<el-input 
						ref="waybillInputRef" 
						v-model="workForm.waybillNo" 
						placeholder="请输入单个运单号" 
						clearable 
						@blur="fetchWaybillInfo"
					>
						<!-- Ticket 仍在使用 -->
						<template #prefix><el-icon><Box /></el-icon></template>
					</el-input>
				</el-form-item>

				<!-- 仅当类型为更址时显示收件人信息 -->
				<template v-if="workForm.workType === 'changeRecipient'">
					<el-divider content-position="left">新收件人信息</el-divider>
					
					<!-- 智能解析区域 -->
					<div class="smart-parse-box">
						<el-input 
							v-model="parseText" 
							type="textarea" 
							:autosize="{ minRows: 2, maxRows: 3 }"
							placeholder="示例：张三 13800138000 北京市朝阳区xxx路xxx号" 
							resize="none" 
							clearable 
							class="parse-input"
						/>
						<div class="parse-action">
							<!-- MagicStick 仍在使用 -->
							<el-button type="primary" plain size="small" @click="structured('recipient', parseText)" :loading="structuredLoading">
								<el-icon style="margin-right: 4px;"><MagicStick /></el-icon> 智能解析
							</el-button>
						</div>
					</div>

					<el-row :gutter="20">
						<el-col :span="11">
							<el-form-item label="姓名" prop="recipient.name">
								<el-input v-model="workForm.workData.recipient.name" placeholder="收件人姓名" clearable />
							</el-form-item>
						</el-col>
						<el-col :span="13">
							<el-form-item label="电话" prop="recipient.mobile">
								<el-input v-model="workForm.workData.recipient.mobile" placeholder="手机或座机" clearable />
							</el-form-item>
						</el-col>
					</el-row>

					<el-form-item label="所在地区" prop="recipient.area_code">
						<el-cascader 
							v-model="workForm.workData.recipient.area_code" 
							ref="recipient_area"
							@change="area_change('recipient')" 
							separator=" - " 
							placeholder="请选择省市区"
							:options="areaData" 
							:props="{ label:'name', value:'adcode', children:'districts' }" 
							clearable
							filterable 
							style="width: 100%;"
						/>
					</el-form-item>

					<el-form-item label="详细地址" prop="recipient.address">
						<el-input v-model="workForm.workData.recipient.address" placeholder="街道、门牌号等详细信息" clearable />
					</el-form-item>
				</template>


				<el-form-item label="问题描述" prop="describe">
					<el-input 
						v-model="workForm.workData.describe" 
						type="textarea" 
						:rows="3" 
						placeholder="选填，描述具体问题或需求" 
						maxlength="200" 
						show-word-limit
					/>
				</el-form-item>
			</el-form>

			<template #footer>
				<div class="dialog-footer">
					<el-button @click="showCreateWorkOrder = false">取消</el-button>
					<el-button type="primary" @click="submitForm" :loading="submitLoading">提交工单</el-button>
				</div>
			</template>
		</el-dialog>
	</div>
</template>

<script>
	// 修复：只导入实际使用的图标组件
	import { CopyDocument, Box, MagicStick } from '@element-plus/icons-vue';
	import areaData from "@/assets/areaCode.json"; // 假设路径正确

	export default {
		// 修复：只注册使用的组件
		components: { CopyDocument, Box, MagicStick },
		data() {
			return {
				areaData: areaData,
				tableLoading: false,
				submitLoading: false,
				structuredLoading: false,
				
				// 搜索表单
				searchForm: {
					waybillNo: '',
					status: ''
				},
				
				// 分页
				pagination: {
					currentPage: 1,
					pageSize: 10,
					total: 0
				},

				workList: [],
				showCreateWorkOrder: false,
				
				// 表单数据
				workForm: {
					cpCode: "YTO",
					waybillNo: "",
					workType: "intercept", // 默认退回
					workData: {
						recipient: {
							name: '',
							mobile: '',
							provinceName: '',
							cityName: '',
							districtName: '',
							address: '',
							areaCode: "",
							area_code: [] 
						},
						describe: ""
					}
				},
				
				workTypeList: [
					{ name: "拦截/退回", code: "intercept" },
					{ name: "更改地址", code: "changeRecipient" }
				],
				
				parseText: "",
				
				// 校验规则
				rules: {
					waybillNo: [
						{ required: true, message: '请输入运单号', trigger: 'blur' }
					],
					'recipient.name': [
						{ required: true, message: '姓名必填', trigger: 'blur' }
					],
					'recipient.mobile': [
						{ required: true, message: '联系电话必填', trigger: 'blur' },
						{ pattern: /^1[3-9]\d{9}$|^\d{3,4}-?\d{7,8}$/, message: '请输入正确的手机号或座机号', trigger: 'blur' }
					],
					'recipient.area_code': [
						{ required: true, message: '请选择省市区', trigger: 'change' }
					],
					'recipient.address': [
						{ required: true, message: '详细地址必填', trigger: 'blur' }
					]
				},
			}
		},
		created() {
			this.getWorkList()
		},
		methods: {
			// 获取工单列表
			getWorkList() {
				this.tableLoading = true;
				const params = {
					...this.searchForm,
					page: this.pagination.currentPage,
					pageSize: this.pagination.pageSize
				};
				
				this.apiService.post({ modules: "getWorkList_internal", content: params })
					.then(res => {
						if (res.status) {
							this.workList = res.data.workList || [];
							this.pagination.total = res.data.total || 0;
						}
					})
					.finally(() => {
						this.tableLoading = false;
					})
			},
			
			// 搜索
			handleSearch() {
				this.pagination.currentPage = 1;
				this.getWorkList();
			},
			
			// 重置搜索
			resetSearch() {
				this.searchForm = { waybillNo: '', status: '' };
				this.handleSearch();
			},
			
			// 分页变化
			handleSizeChange(val) {
				this.pagination.pageSize = val;
				this.getWorkList();
			},
			handleCurrentChange(val) {
				this.pagination.currentPage = val;
				this.getWorkList();
			},

			// 打开弹窗
			openCreateDialog() {
				// 重置表单
				this.workForm = {
					cpCode: "YTO",
					waybillNo: "",
					workType: "intercept",
					workData: {
						recipient: {
							name: '', mobile: '', provinceName: '', cityName: '', districtName: '', address: '', areaCode: "", area_code: []
						},
						describe: ""
					}
				};
				this.parseText = "";
				this.showCreateWorkOrder = true;
			},
			
			// 弹窗打开后聚焦
			dialogOpened() {
				this.$nextTick(() => {
					if (this.$refs.waybillInputRef) {
						this.$refs.waybillInputRef.focus();
					}
					// 清除校验结果
					if(this.$refs.workFormRef) {
						this.$refs.workFormRef.clearValidate();
					}
				});
			},
			
			// 模拟根据运单号获取信息（可选）
			fetchWaybillInfo() {
				if(!this.workForm.waybillNo) return;
				// 这里可以调用接口获取发件人信息等预填充
			},

			// 提交表单
			submitForm() {
				this.$refs.workFormRef.validate((valid) => {
					if (valid) {
						this.submitLoading = true;
						// 构造提交数据
						const submitData = {
							cpCode: this.workForm.cpCode,
							waybillNo: this.workForm.waybillNo,
							workType: this.workForm.workType,
							workData: { ...this.workForm.workData }
						};
						
						// 如果是更址，确保省市区名称也带上（如果后端需要）
						if(submitData.workType === 'changeRecipient') {
							// area_code 是数组，可能需要转换为字符串或保留数组，视后端而定
						}

						this.apiService.post({ modules: "createWorkOrder_internal", content: submitData })
						.then(res => {
							if (res.status) {
								this.$message.success('工单创建成功');
								this.showCreateWorkOrder = false;
								this.getWorkList(); // 刷新列表而不是 reload
							} else {
								this.$message.error(res.msg || '创建失败');
							}
						})
						.finally(() => {
							this.submitLoading = false;
						})
					} else {
						this.$message.warning('请检查表单填写是否正确');
						return false;
					}
				});
			},
			
			// 智能解析
			structured(to, text) {
				if (!text) {
					this.$message.warning('请输入需要解析的文本');
					return;
				}
				this.structuredLoading = true;
				this.apiService.post({
						modules: "structured",
						content: { text: text }
					})
					.then((res) => {
						if (res.status && res.data && res.data.length > 0) {
							const data = res.data[0];
							const target = this.workForm.workData[to];
							
							target.name = data.name || '';
							target.mobile = data.mobile || data.tel || '';
							target.address = data.address || '';
							
							// 处理地区编码
							if (data.areaCode) {
								target.areaCode = data.areaCode;
								// 构造级联选择器需要的数组格式 [省code, 市code, 区code]
								// 注意：这里假设 areaCode 是6位行政区划代码
								const code = data.areaCode;
								if(code.length >= 6) {
									target.area_code = [
										code.substring(0, 2) + '0000',
										code.substring(0, 4) + '00',
										code
									];
									// 触发 change 事件以更新省市区名称
									this.area_change(to);
								}
								
								target.provinceName = data.provinceName || '';
								target.cityName = data.cityName || '';
								target.districtName = data.districtName || '';
							}
							this.$message.success('解析成功');
						} else {
							this.$message.warning('未能识别有效信息，请手动填写');
						}
					})
					.finally(() => {
						this.structuredLoading = false;
					})
			},
			
			// 级联选择器变化
			area_change(to) {
				// 注意：el-cascader 的 getCheckedNodes 方法在 Vue3 + Element Plus 中可能需要通过 ref 访问
				const cascaderRef = this.$refs[to + '_area'];
				if (cascaderRef) {
					const checkedNodes = cascaderRef.getCheckedNodes();
					if (checkedNodes && checkedNodes.length > 0) {
						// pathLabels 包含从根到当前节点的所有标签
						const labels = checkedNodes[0].pathLabels;
						const target = this.workForm.workData[to];
						target.provinceName = labels[0] || '';
						target.cityName = labels[1] || '';
						target.districtName = labels[2] || '';
					}
				}
			},
			
			// 辅助：获取状态标签类型
			getStatusType(status) {
				const map = {
					'PROCESSING': 'primary',
					'COMPLETED': 'success',
					'CANCELLED': 'info'
				};
				return map[status] || '';
			},
			
			viewDetail(row) {
				console.log('查看详情', row);
				this.$message.info('查看详情功能开发中');
			},
			
			// 修复：使用 id 参数
			cancelWorkOrder(id) {
				this.$confirm('确定要取消该工单吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// 模拟使用 id
					console.log('Cancelling order with ID:', id);
					// 调用取消接口
					this.$message.success(`工单 ${id} 已取消`);
					this.getWorkList();
				}).catch(() => {});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.work-order-container {
		padding: 20px;
		background-color: #f5f7fa;
		min-height: 100vh;
	}

	.header-card {
		background: #fff;
		padding: 10px;
		border-radius: 8px;
		margin-bottom: 20px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
	}

	.table-card {
		background: #fff;
		padding: 20px;
		border-radius: 8px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
		
		.pagination-container {
			margin-top: 20px;
			display: flex;
			justify-content: flex-end;
		}
	}

	.waybill-cell {
		display: flex;
		align-items: center;
		.waybill-text {
			color: #409EFF;
			cursor: pointer;
			margin-right: 8px;
			&:hover {
				// text-decoration: underline;
			}
		}
		.copy-icon {
			cursor: pointer;
			color: #909399;
			&:hover {
				color: #409EFF;
			}
		}
	}

	// 弹窗内样式
	.custom-form {
		padding: 0 10px;
	}

	.type-selector {
		display: flex;
		gap: 15px;
		
		.type-btn {
			padding: 8px 24px;
			border-radius: 4px;
			background-color: #f4f4f5;
			color: #909399;
			cursor: pointer;
			transition: all 0.3s;
			border: 1px solid transparent;
			
			&:hover {
				color: #409EFF;
				background-color: #ecf5ff;
			}
			
			&.active {
				background-color: #ecf5ff;
				color: #409EFF;
				border-color: #409EFF;
				font-weight: bold;
			}
		}
	}

	.smart-parse-box {
		background-color: #f9fafc;
		border: 1px dashed #dcdfe6;
		border-radius: 4px;
		padding: 10px;
		margin-bottom: 15px;
		
		.parse-input {
			margin-bottom: 10px;
		}
		
		.parse-action {
			display: flex;
			justify-content: flex-end;
		}
	}
	
	:deep(.el-divider__text) {
		font-weight: bold;
		color: #303133;
	}
</style>